<script lang="ts" setup>
const { loading } = storeToRefs(useAuthStore())

const route = useRoute()
</script>

<template>
  <div class="flex flex-col min-h-screen">
    <div class="">
      <Loader :show="loading" />
      <slot />
    </div>
  </div>
</template>
